import Model from 'vue-interface/src/Http/Model';

export default class Page extends Model {
    endpoint() {
        return 'page';
    }
}
